import { Outlet } from 'react-router-dom';
import * as S from './styles';

import OrganizerContainer from 'modules/organizer/ui/components/organizer-contrainer';
import React from 'react';
import UDCopyright from '../../components/copyright';
import UDMenu from '../../components/menu';
import { useMainLayout } from './context';
import JivoChatLoader from 'modules/support-chat/components/jivo-chat-loader';
import { Menu } from 'lucide-react';

type Props = {
  children?: React.ReactNode;
  headerContent?: React.ReactNode;
  contentClassName?: string;
};

const UDMainLayout = React.memo((props: Props) => {
  const { headerContent, contentClassName } = useMainLayout();
  const [isMobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const openMenu = React.useCallback(() => setMobileMenuOpen(true), []);
  const closeMenu = React.useCallback(() => setMobileMenuOpen(false), []);

  React.useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeMenu();
    };
    if (isMobileMenuOpen) {
      document.addEventListener('keydown', onKeyDown);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen, closeMenu]);

  return (
    <OrganizerContainer>
      {(isLoading, info) => (
        <S.Container>
          <S.Menu>
            <UDMenu isOrganizerLoading={isLoading} organizerInfo={info} />
          </S.Menu>
          <S.Header>
            <S.BurgerButton aria-label="Открыть меню" onClick={openMenu} className="mr-2">
              <Menu />
            </S.BurgerButton>
            {headerContent || props.headerContent}
          </S.Header>

          {isMobileMenuOpen && (
            <>
              <S.MobileMenuOverlay onClick={closeMenu} />
              <S.MobileMenuPanel>
                <UDMenu isOrganizerLoading={isLoading} organizerInfo={info} />
              </S.MobileMenuPanel>
            </>
          )}

          <S.MainBlockWrapper>
            <S.Content className={contentClassName || props.contentClassName}>
              <JivoChatLoader />
              <Outlet />
            </S.Content>
            <S.Footer className="bt-1 container py-6">
              <a className="link text callout mr-6" href="https://imgameapp.ru/#organizer" target="_blank" rel="noreferrer">
                О приложении
              </a>
              <a className="link text callout mr-6" href="https://imgameapp.ru/privacy-policy" target="_blank" rel="noreferrer">
                Политика конфиденциальности
              </a>
              <a className="link text callout mr-6" href="https://imgameapp.ru/terms-and-conditions" target="_blank" rel="noreferrer">
                Условия использования
              </a>
              <UDCopyright className="d-inline-block ml-auto" />
            </S.Footer>
          </S.MainBlockWrapper>
        </S.Container>
      )}
    </OrganizerContainer>
  );
});

export default UDMainLayout;
